import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './base';
import { AiQueryDTO } from '../../models/ai-query';
import { Response } from '../../models/shared';

const aiQueryApi = createApi({
  reducerPath: 'aiQueryApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['aiQuery'],
  endpoints: (builder) => ({
    generateAiQuery: builder.mutation<Response<AiQueryDTO>, { contextJson: string, businessId: string }>({
      query: ({ contextJson, businessId }) => ({
        url: `/businesses/${businessId}/ai-queries/generate`,
        method: 'POST',
        body: {
          prompt: 'Generate report',
          context_json: contextJson,
        },
      }),
      invalidatesTags: ['aiQuery'],
    }),
  }),
});

export const {
  useGenerateAiQueryMutation,
} = aiQueryApi;
export { aiQueryApi };
